import { ILookup } from '@morningstar/shared/models';
import { BaseComparisonOperatorOptions } from './base-comparison-operators';

export class TextComparisonOperatorOptions implements ILookup<string> {
  id: string;
  description: string;

  static contains: TextComparisonOperatorOptions = { id: 'LIKE', description: 'Contains' };
  static notContains: TextComparisonOperatorOptions = { id: 'NOT LIKE', description: 'Not Contains' };

  static get options(): ILookup<string>[] {
    return [ 
      ...BaseComparisonOperatorOptions.options,
      TextComparisonOperatorOptions.contains,
      TextComparisonOperatorOptions.notContains
    ];
  }
}